import { Box } from '@mantine/core';
import { useFitScale } from 'src/secret-menu/brand-asset-builder/hooks/useFitScale';

type PreviewCanvasProps = {
  nativeWidth: number;
  nativeHeight: number;
  children: React.ReactNode;
};

export default function PreviewCanvas({ nativeWidth, nativeHeight, children }: PreviewCanvasProps) {
  const { containerRef, scale } = useFitScale(nativeWidth, nativeHeight);

  return (
    <Box
      style={{
        borderRadius: 'var(--mantine-radius-md)',
        backgroundColor: 'var(--mantine-color-gray-1)',
        backgroundImage: 'radial-gradient(var(--mantine-color-gray-4) 1px, transparent 1px)',
        backgroundSize: '14px 14px',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Box
        ref={containerRef}
        p="xl"
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
        }}
      >
        <Box
          style={{ width: nativeWidth * scale, height: nativeHeight * scale, position: 'relative' }}
        >
          <Box
            style={{
              width: nativeWidth,
              height: nativeHeight,
              transform: `scale(${scale})`,
              transformOrigin: 'top left',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
